import React from 'react'
import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'
import { GlobalStyle, themes } from 'styles'

import Tutorial from './tutorial'

const renderLayout = (layout, props) => {
  switch (layout) {
    case 'tutorial':
      return <Tutorial {...props} />
    default:
      return props.children
  }
}

const Layout = (props) => (
  <ThemeProvider theme={themes.light}>
    <GlobalStyle />
    {renderLayout(props.pageContext?.layout, props)}
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
